import ProductCard from '../productCard';
import { FC } from 'react';
import { TypeCatalogue } from '../../types/products';
import SkeletonProducts from '../skeletonProducts';
import searchIcon from './../../assets/images/catalogue/searchIcon.png';
import './ProductList.scss';
interface IProductList {
  data: TypeCatalogue;
  loading: boolean;
}
const ProductList: FC<IProductList> = ({ data, loading }: IProductList) => {
  const generateProductCards = () => {
    return data.map(item => {
      return (
        <ProductCard
          key={`img-product-list-name-${item.commercialName}-id-${item.productId}-uid-${item.uid}`}
          product={item}
        />
      );
    });
  };

  return (
    <div id="productList">
      <div className="headerList">
        <div className="headerColumn skuSection">SKU</div>
        <div className="headerColumn categorySection">Categoría</div>
        <div className="headerColumn photoSection">Foto</div>
        <div className="headerColumn brandSection">Marca</div>
        <div className="headerColumn nameSection">Nombre Comercial</div>
        <div className="headerColumn characteristicsSection">Caracterisiticas</div>
        <div className="headerColumn availableCountriesSection">Países activos para venta </div>
      </div>
      <div className="containerCards">
        {loading ? <SkeletonProducts /> : <> {data && data.length > 0 && generateProductCards()}</>}
        {!loading && data.length === 0 && (
          <div className="notFound">
            <div className="verticalCenter">
              <div className="boxNoFound">
                <div className="positionIcon">
                  <img alt="searchIcon" src={searchIcon} />
                </div>
                <div className="textNoFound">No hay resultados para tu busqueda </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProductList;
